import React, { Component } from "react";
import { Form, Row, Col, Button, ListGroup, Alert, Modal } from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";


import "containers/common/List.css";
import ReactTable from "react-table";
import 'react-table/react-table.css';
import Moment from "moment";
import DatePicker from "react-datepicker";


export default class SalesSheetList extends Component {
    constructor(props) {
        super(props);

        this.state = {
            searching: false,
            isLoading: true,
            filter: {},
            dataSet: "propertySaleSheets",
            dataRecord: "propertySaleSheets",
            dataSetPrimaryKey: "property_sale_sheet_id",
            showAlert: false,
            errorMessage: "",
            savingNewRecord: false
        };

        
        this.handleDeleteRecord = this.handleDeleteRecord.bind(this);
    }
    

    async componentDidMount() {
    
        if (!this.props.isAuthenticated) { // if false
            return;
        }

       
      
        this.setState({ isLoading: false });      
    }



    async handleDataSave(data) {
        try {
            return await this.props.saveRecord(data, this.state.dataSet, this.state.dataSetPrimaryKey);



        } catch (e) {
            alert("Error saving");
        }
    }



    handleDeleteRecord = async (cellInfo, event) => {
        event.preventDefault();
        console.log("delete address");
        let data = [...this.props.data];
        var r = window.confirm("Are you sure you want to delete this record?");
        if (r === true) {
            console.log(cellInfo);

            data[cellInfo.index].archived_date = new Date();
            await this.handleDataSave(data[cellInfo.index]).then((result) => {
                data.splice(cellInfo.index, 1);
                this.props.updateTableState(data, this.state.dataSet);
            }
            )
        };
    };

    handleInputChange = (cellInfo, event) => {
        console.log(typeof (event.target.value));
        let data = [...this.props.data];
        data[cellInfo.index][cellInfo.column.id] = event.target.value.toUpperCase();
        data[cellInfo.index].modified = true;
        this.props.updateTableState(data, this.state.dataSet);
    };
    handleNumberChange = (cellInfo, event) => {
        let data = [...this.props.data];
        let val = event.target.value.replace(/[^0-9]/g, "");
        
        data[cellInfo.index][cellInfo.column.id] = val;
        data[cellInfo.index].modified = true;
        this.props.updateTableState(data, this.state.dataSet);
    };
    handleCheckboxChange = (cellInfo, event) => {
        let data = [...this.props.data];
        data[cellInfo.index][cellInfo.column.id] = event.target.checked;
        data[cellInfo.index].modified = true;
        this.props.updateTableState(data, this.state.dataSet);
    };

    handleDateChange = (cellInfo, event) => {
        let data = [...this.props.data];
        data[cellInfo.index][cellInfo.column.id] = new Date(event);
        data[cellInfo.index].modified = true;
        this.props.updateTableState(data, this.state.dataSet);

    }

    handleSave = async (cellInfo, event) => {

        this.setState({ showAlert: false });
        let data = [...this.props.data];
        for (var i=0; i<data.length; i++){
            const validation = this.props.validateRelatedRecord(data[i], this.state.dataSet);
            console.log(validation[0]);
            if (validation[0] === true) {
                if (data[i].hasOwnProperty("modified")) {
                    if (data[i].modified === true) {
                        console.log(i);
                        //Save the data
                        if (!this.state.savingNewRecord) {
                            if (data[i].hasOwnProperty("new_record")) {
                                if (data[i].new_record === true) {
                                    this.setState({ savingNewRecord: true });
                                }
                            }
                            const result = await this.handleDataSave(data[i]);
                            if (result.result) {
                                data[i].modified = false;
                                if (data[i].hasOwnProperty("new_record")) {
                                    if (data[i].new_record === true) {

                                        data[i][this.state.dataSetPrimaryKey] = result.id;
                                        this.setState({ savingNewRecord: false });
                                    }
                                    data[i].new_record = false;
                                }
                                                               
                            }
                            else {
                                this.setState({ errorMessage: result.error_message });
                                this.setState({ showAlert: true });
                            }
                        }
                    }

                }
            }
            else {
                this.setState({ errorMessage: validation[1] });
                this.setState({ showAlert: true });
                return;
            }
        }   
        if (data[0].hasOwnProperty("sale_follow_up_date")) {
            data.sort(function (a, b) { return b.sort_order - a.sort_order });
        }
        if (data[0].hasOwnProperty("current")) {
            data.sort(function (a, b) { return (a.current === b.current)? 0 : a.current ? -1 : 1 });
        }
        // /sale_follow_up_date
        //current

        this.props.updateTableState(data, this.state.dataSet);


    }

    addRecord = async event => {
        let data = [...this.props.data];

        //Update the following with the minimum details to create a record (all not nulls populated)
        //Requires updating per dataset
        data.unshift({
            property_sale_sheet_id: "",
            property_id: null,
            property_key: "",
            sale_sheet_id: this.props.salesheetid,
           
            created_by: this.props.user,
            last_edited_by: this.props.user,
            new_record: true

        });
        this.props.updateTableState(data, this.state.dataSet);
    }


  


    renderEditable = cellInfo => {
        const cellValue = this.props.data[cellInfo.index][cellInfo.column.id];

        switch (typeof (cellValue)) {
            case "boolean":
                return (
                    <Form.Check checked={cellValue}
                        onChange={this.handleCheckboxChange.bind(null, cellInfo)}
                        label=""
                        type="checkbox"
                        onBlur={this.handleSave.bind(null, cellInfo)}
                        disabled
                    />);

                    case "number":
                        return (
                            <input
                                onChange={this.handleNumberChange.bind(null, cellInfo)}
                                onBlur={this.handleSave.bind(null, cellInfo)}
                                type="number"
                                className="no-border form-control"
                                value={cellValue!=null? cellValue: " "}
        
                            />
                        );
        
                    default:
                        if (cellInfo.column.id.indexOf("date") >= 0) {
                            return (
                                <DatePicker
                                    selected={cellValue!=null?  new Date(cellValue):""}
                                    onChange={this.handleDateChange.bind(null, cellInfo)}
                                    onBlur={this.handleSave.bind(null, cellInfo)}
                                    dateFormat="dd/MM/yyyy"
                                    className="no-border form-control"
                                />);
                        }
                        else {
                            return (
                                <input
                                    onChange={this.handleInputChange.bind(null, cellInfo)}
                                    onBlur={this.handleSave.bind(null, cellInfo)}
                                    type="text"
                                    className="no-border form-control"
                                    value={cellValue!=null? cellValue:""}
        
                                />
                            );
                        }

        }
    }


    renderTable(data) {
        const columns = [

            {
                id: 'sale_sheet_id',
                Header: 'ID',
                maxWidth: 60,
                accessor: 'sale_sheet_id' ,
                Cell: e => <LinkContainer to={{ pathname:`/properties/${e.original.property_key}/salesheets/${e.value}`, state: {data: this.props.data.map(a => a.sale_sheet_id), propertyidlist: this.props.idList}}}><a> {e.value} </a></LinkContainer>

            }
            , {
                id: 'property_key',
                Header: 'Cityscope Ref',
                accessor: 'property_key',
                Cell: this.renderEditable,
                maxWidth: 80

            }
            , {
                id: 'current',
                Header: 'Current',
                accessor: 'current',
                Cell: this.renderEditable,
                maxWidth: 80,
                style: { textAlign: "center" }
            }
            
            , {
                id: 'sale_status',
                Header: 'Sale Status',
                accessor: 'sale_status',
                maxWidth: 150

            },
            {
                id: 'agent_1',
                Header: 'Agent 1',
                accessor: 'agent_1',
                maxWidth: 200

            },
            {
                id: 'agent_2',
                Header: 'Agent 2',
                accessor: 'agent_2',
                maxWidth: 200

            },
            {
                id: 'sale_follow_up_date',
                Header: 'Next Follow Up Date',
                accessor: d => {
                    if (d.sale_follow_up_date) {
                        return Moment(d.sale_follow_up_date)
                            .local()
                            .format("DD-MM-YYYY")
                    }
                    else { return null }
                },
                maxWidth: 130
            }, {
                id: 'sale_status_date_checked',
                Header: 'Last Follow Up Date',
                accessor: d => {
                    if (d.sale_status_date_checked) {
                        return Moment(d.sale_status_date_checked)
                            .local()
                            .format("DD-MM-YYYY")
                    }
                    else { return null }
                },
                maxWidth: 130
            },
        
            {
                Header: '',
                accessor: 'property_sale_sheet_id',
                maxWidth: 65,
                Cell: row => <Button type="button" size="sm" variant="danger" onClick={(e) => this.handleDeleteRecord(row,e)}>Delete</Button>
            }
        ]

        if (!data) {
            return null
        }
        else {
            return (
                <ReactTable
                    data={data}
                    columns={columns}
                    defaultPageSize={10}
                    sortable={false}
                />
            )
        }



    }

    renderTable2(data) {
        const columns = [

            {
                id: 'sale_sheet_id',
                Header: 'ID',
                maxWidth: 60,
                accessor: 'sale_sheet_id'

            }, {
                id: 'property_key',
                Header: 'Cityscope Reference',
                accessor: 'property_key',
                maxWidth: 200,
                Cell: this.renderEditable
            }
            ,
            {
                Header: '',
                accessor: 'property_sale_sheet_id',
                maxWidth: 65,
                Cell: row => <Button type="button" size="sm" variant="danger" onClick={(e) => this.handleDeleteRecord(row, e)}>Delete</Button>
            }
        ]

        if (!data) {
            return null
        }
        else {
            return (
                <ReactTable
                    data={data}
                    columns={columns}
                    defaultPageSize={10}
                    sortable={false}
                />
            )
        }

    }

    renderTable3(data) {
        const columns = [

            // {
            //     id: 'sale_sheet_id',
            //     Header: 'ID',
            //     maxWidth: 60,
            //     accessor: 'sale_sheet_id' ,
            //     Cell: e => <LinkContainer to={`../salesheets/${e.value}`}><a> {e.value} </a></LinkContainer>

            // }
            // , 
            {
                id: 'property_key',
                Header: 'Cityscope Reference',
                accessor: 'property_key',
                maxWidth: 120,
                Cell: e => <LinkContainer to={`../properties/${e.value}`}><a>{e.value}</a></LinkContainer>
            }
            , {
                id: 'current',
                Header: 'Current',
                accessor: 'current',
                maxWidth: 80,                
                style: { textAlign: "center" },
                Cell: e=><Form.Check checked={e.value}                              
                                type="checkbox"
                                disabled
                            />
            }
            
            , {
                id: 'sale_status',
                Header: 'Sale Status',
                accessor: 'sale_status',
                maxWidth: 250

            },
            {
                id: 'sale_follow_up_date',
                Header: 'Next Follow Up Date',
                accessor: d => {
                    if (d.sale_follow_up_date) {
                        return Moment(d.sale_follow_up_date)
                            .local()
                            .format("DD-MM-YYYY")
                    }
                    else { return null }
                },
                maxWidth: 130
            }, {
                id: 'sale_status_date_checked',
                Header: 'Last Follow Up Date',
                accessor: d => {
                    if (d.sale_status_date_checked) {
                        return Moment(d.sale_status_date_checked)
                            .local()
                            .format("DD-MM-YYYY")
                    }
                    else { return null }
                },
                maxWidth: 130
            }
            
        ]

        if (!data) {
            return null
        }
        else {
            return (
                <ReactTable
                    data={data}
                    columns={columns}
                    defaultPageSize={20}
                    sortable={false}
                />
            )
        }

    }

    //QRY.cityscope,coalesce(QRY.map_number,0), UPPER(COALESCE(QRY.map_number_suffix,'')), coalesce(QRY.property_number,0), UPPER(coalesce(QRY.property_number_suffix,'')), coalesce(QRY.unit_sort,0)
    //Modify the attribute shown in the list for each type of record
    renderList(data) {
        if (!data) {
            return null
        }
        else {
            return [{}].concat(data).map(
                (d, i) =>
                    i !== 0 ? 
                            <ListGroup.Item key={i}  header={d.property_key}><LinkContainer key={i} to={`/properties/${d.property_key}`}><a>{d.property_key+" - "+d.street_address+" - "+d.title_details}</a></LinkContainer></ListGroup.Item>                        
                        : ""
            );
        }
    }

    
    renderComponent() {
        return (
            <div className="salessheets">
                <Modal show={this.state.showAlert} onHide={(e)=>{this.setState({showAlert: !this.state.showAlert})}} centered >
                    <Modal.Header closeButton> <Modal.Title>Uh Oh!</Modal.Title></Modal.Header>
                    <Modal.Body > <Alert variant="danger"  >{this.state.errorMessage}</Alert> </Modal.Body>
                </Modal>
                {(this.props.controlType === "table" || this.props.controlType === "table2") && <Row >
                    <Col className="text-right" >
                        {/*   <Button variant="secondary" size="sm" onClick={this.props.refreshDataSet}  >Refresh</Button>  */}
                        {this.props.controlType === "table" && <LinkContainer to={`/properties/${this.props.propertykey}/salesheets/new?propertyid=${this.props.propertyid}`}><Button variant="secondary" size="sm">Add</Button></LinkContainer>}
                        {this.props.controlType === "table2" && <Button variant="secondary" size="sm" onClick={this.addRecord}>Add</Button>}

                    </Col>
                </Row>}

                    <Row className="show-Container">
                        <Col sm={12} md={12} lg={12}>
                        {!this.state.isLoading && this.props.controlType == "table" ? this.renderTable(this.props.data) : this.props.controlType == "table2" ? this.renderTable2(this.props.data) :this.props.controlType == "table3" ? this.renderTable3(this.props.data) : this.renderList(this.props.data)}
                        </Col>
                    </Row>
            

            </div>
        );
    }
  render() {
    return (

        <div className="SalesSheetList">
            {this.props.isAuthenticated ? this.renderComponent() : console.log("error)")}
        </div>
    );
  }
}
